import { API } from "../../../utils";

export const changePassword = async (payload) => {
  const res = await API.post("user/updatePassword", payload);
  return res.data;
};

